import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import AsyncSelect from "react-select/lib/Async";
import { NumberField } from "../../../../../../../../Utils/renderField/fieldsHookForms";
import { useDebouncedAsyncSelect } from "../../../../../../../../Utils/Hooks/useDebounce";
import { CreacionPaletizacionApi } from "../../api/CreacionPaletizacionApi";
import { maxFloatNumber } from "../../../../../../../../Utils/renderField/hookForms";
import { ContenidoReclasificacion } from "./ContenidoReclasificacion";
import { formatDisplayNumber } from "../../../../../../../../../../utility/utils";
import {
    calcularTotalesSobrante,
    pacasCompletasSobrantePorPadre,
} from "../../hooks/useSobranteReclasificacion";

const desplegarIcon = require("assets/img/icons/external-icon.png");

export const PalletForm = (props) => {
    const {
        prodSinPaletizar,
        siguienteNumeroPallet,
        palletRechazado,
        AbrirModalNumeroPallet,
        form,
        AgregarPallet,
        AbrirModalReclasificacion,
        inventariosReclasificacion,
        reclasificacionPendiente,
        AbrirModalSobrante,
        sobrantesReclasificacion,
        sobrantePendiente,
    } = props;

    const { getEVSProducidos } = CreacionPaletizacionApi();

    const {
        control: formControl,
        register: formRegister,
        setValue: formSetValue,
        getValues: formGetValues,
        trigger: validateForm,
        watch: watchForm,
        formState: { errors },
    } = form;

    const loadEVS = useDebouncedAsyncSelect(function (search) {
        return getEVSProducidos({ search: search });
    });

    const formValues = watchForm();

    const evsSeleccionado = formValues.evs;

    const productoSeleccionado =
        prodSinPaletizar.productos &&
        evsSeleccionado &&
        prodSinPaletizar.productos.find(function (p) {
            return p.producto_id === evsSeleccionado.producto_id;
        });

    const limitePacasTurnoActual =
        productoSeleccionado && productoSeleccionado.turno_actual
            ? productoSeleccionado.turno_actual.pacas
            : maxFloatNumber;

    const limitePacasTurnoAnterior =
        productoSeleccionado && productoSeleccionado.turno_anterior
            ? productoSeleccionado.turno_anterior.pacas
            : maxFloatNumber;

    const pacasReclasificacion = inventariosReclasificacion.reduce(
        (total, inv) => {
            return (
                total +
                (inv.pacas_a_consumir ? parseInt(inv.pacas_a_consumir) : 0)
            );
        },
        0,
    );

    const palletsReclasificacion = inventariosReclasificacion
        .filter(
            (inv) => inv.pacas_a_consumir && parseInt(inv.pacas_a_consumir) > 0,
        )
        .map((inv) => {
            return {
                pallet_numero: inv.pallet && inv.pallet.numero,
                pallet_identificador_fisico:
                    inv.pallet && inv.pallet.identificador_fisico,
                pacas_consumidas: inv.pacas_a_consumir,
            };
        });

    const totalesSobrante = calcularTotalesSobrante(sobrantesReclasificacion);

    const itemsSobrante =
        totalesSobrante.seleccionados.length > 0
            ? [
                  {
                      es_sobrante: true,
                      pacas_consumidas: totalesSobrante.pacas,
                      detalles: totalesSobrante.seleccionados.map(
                          (existencia) => ({
                              producto_nombre:
                                  existencia.producto &&
                                  existencia.producto.nombre,
                              kg_secos: parseFloat(existencia.kg_a_consumir),
                          }),
                      ),
                  },
              ]
            : [];

    // la reclasificación (pallets o sobrante) de un producto sirve para
    // cualquier producto del mismo padre PT: la disponibilidad se suma por
    // padre a partir de las métricas sin paletizar
    const padreSeleccionadoId =
        productoSeleccionado &&
        productoSeleccionado.padre_producto_terminado_id;

    const reclasificacionDisponibleProducto = (prodSinPaletizar.productos || [])
        .filter((p) => p.padre_producto_terminado_id === padreSeleccionadoId)
        .reduce(
            (total, p) =>
                total +
                Number((p.reclasificacion && p.reclasificacion.pacas) || 0),
            0,
        );

    // pacas completas de sobrante disponibles para el padre PT del producto
    // seleccionado (una fracción de paca no se puede paletizar)
    const sobranteDisponibleProducto =
        pacasCompletasSobrantePorPadre(prodSinPaletizar.sobrantes)[
            padreSeleccionadoId
        ] || 0;

    const reclasificacion = {
        global: reclasificacionPendiente,
        disponibleProducto: reclasificacionDisponibleProducto,
        pacas: pacasReclasificacion,
        pallets: palletsReclasificacion,
        AbrirModal: AbrirModalReclasificacion,
    };

    const sobrante = {
        global: sobrantePendiente,
        disponibleProducto: sobranteDisponibleProducto,
        totalKg: totalesSobrante.totalKg,
        pacas: totalesSobrante.pacas,
        items: itemsSobrante,
        AbrirModal: AbrirModalSobrante,
    };

    const totalPacas =
        (pacasReclasificacion || 0) +
        (totalesSobrante.pacas || 0) +
        parseInt(formValues.pacas_turno_actual || 0) +
        parseInt(formValues.pacas_turno_anterior || 0);

    const [refreshKeyEVS, setRefreshKeyEVS] = useState(0);

    // si el evs se hace null, recargar el listado de evs
    useEffect(() => {
        if (formValues.evs === null) {
            setRefreshKeyEVS((prev) => prev + 1);
        }
    }, [formValues.evs]);

    return (
        <div className="pallet-form d-flex justify-content-between flex-wrap align-items-end mb-3 rounded p-3">
            <h5 className="mb-0">Producción terminada</h5>
            <div className="formulario-fields-row w-100 gap-1rem flex-wrap">
                <div className="formulario-field">
                    <label className="text-nowrap">Pallet a formar</label>
                    <div className="pallet-form__numero">
                        <input
                            type="text"
                            className="form-control pallet-form__numero-input"
                            readOnly
                            title="Click para reutilizar el número de un pallet rechazado"
                            value={
                                palletRechazado
                                    ? palletRechazado.numero
                                    : siguienteNumeroPallet
                            }
                            onClick={AbrirModalNumeroPallet}
                        />
                        <img
                            src={desplegarIcon}
                            alt=""
                            className="pallet-form__numero-icono"
                        />
                    </div>
                    {palletRechazado && (
                        <small className="text-info">Número reutilizado</small>
                    )}
                </div>

                <div className="formulario-field min-w-150">
                    <label className="text-nowrap">EVS</label>
                    <Controller
                        name="evs"
                        control={formControl}
                        rules={{
                            required: "Debe seleccionar un EVS",
                        }}
                        render={({ field }) => (
                            <AsyncSelect
                                {...field}
                                key={refreshKeyEVS}
                                className="react-select-container"
                                isSearchable
                                isClearable
                                defaultOptions
                                loadOptions={loadEVS}
                                getOptionValue={(option) =>
                                    option.orden_produccion_id
                                }
                                getOptionLabel={(option) =>
                                    `${option.evs_numero} - ${option.producto_nombre}`
                                }
                                onChange={(selected) => {
                                    field.onChange(selected);

                                    // validar todo el formulario
                                    validateForm();
                                }}
                            />
                        )}
                    />
                    {errors.evs && (
                        <small className="text-danger">
                            {errors.evs.message}
                        </small>
                    )}
                </div>

                <div className="formulario-field">
                    <label className="text-nowrap">Tipo de producto</label>
                    <input
                        type="text"
                        className="form-control"
                        disabled
                        value={
                            formValues.evs && formValues.evs.producto_nombre
                                ? formValues.evs.producto_nombre
                                : ""
                        }
                    />
                </div>

                <div className="formulario-field">
                    <label className="text-nowrap">Pacas turno actual</label>
                    <NumberField
                        control={formControl}
                        name="pacas_turno_actual"
                        errors={errors}
                        allowNegative={false}
                        rules={{
                            min: {
                                value: 0,
                                message: "La cantidad no puede ser negativa",
                            },
                            max: {
                                value: limitePacasTurnoActual,
                                message: `No puede ingresar más de ${formatDisplayNumber(limitePacasTurnoActual)} pacas de turno actual para este producto`,
                            },
                        }}
                        decimalScale={0}
                    />
                </div>

                <div className="formulario-field">
                    <label className="text-nowrap">Pacas turno anterior</label>
                    <NumberField
                        control={formControl}
                        name="pacas_turno_anterior"
                        errors={errors}
                        allowNegative={false}
                        rules={{
                            min: {
                                value: 0,
                                message: "La cantidad no puede ser negativa",
                            },
                            max: {
                                value: limitePacasTurnoAnterior,
                                message: `No puede ingresar más de ${formatDisplayNumber(limitePacasTurnoAnterior)} pacas de turno anterior para este producto`,
                            },
                        }}
                        decimalScale={0}
                    />
                </div>
            </div>

            <ContenidoReclasificacion
                hayProductoSeleccionado={!!evsSeleccionado}
                reclasificacion={reclasificacion}
                sobrante={sobrante}
            />

            <div className="formulario-fields-row w-100 gap-1rem flex-wrap mb-0 mt-0">
                <div className="formulario-field horizontal no-flex ml-auto">
                    <label className="text-nowrap">Total de pacas</label>
                    <div>
                        <input
                            type="text"
                            className="form-control"
                            disabled
                            value={formatDisplayNumber(totalPacas)}
                            style={{ minWidth: "120px" }}
                        />
                    </div>
                </div>
                <div className="formulario-field no-flex">
                    <button
                        type="button"
                        className="btn btn-primary ml-auto"
                        onClick={AgregarPallet}
                    >
                        Agregar
                    </button>
                </div>
            </div>
        </div>
    );
};
